<script>
    import * as api from '../../shared/api.js'
    import SourceProgress from './SourceProgress.svelte'

    export let item
    let loading  = false
    let error    = false
    let statuses = []

    function loadSources(status) {
        if(status === 'EXECUTING' 
            || status === 'GENERATING REPORT'
            || status === 'REPORT SUCCESS'
            || status === 'REPORT AVAILABLE'            
            || status === 'REPORT ERROR') {
            loading = true
            api .get(`/inquiry/${item.inquiry.protocol}/progress`)
                .then(api.toJsonIf200)
                .then(data => {
                    loading  = false
                    statuses = data
                })
                .catch(err => {
                    loading = false
                    error = err
                })
        } else {
            statuses = []
        }
    }

    function reason(transitions) {
        const tr = transitions.find(tr => tr.status === 'DENIED')
        if(tr) {
            switch(tr.data.reason) {
                case 'NOT_FOUND': return 'Não foi possível identificar o titular'
                case 'MISSING'  : return 'Não existem dados disponíveis para o titular'
                case 'BLOCKED'  : return 'Determinação Judicial' 
                case 'OTHER'    : return tr.data.explanation
                default         : return tr.data.reason
            }
        }
    }

    $: loadSources(item.inquiry.status)

</script>

<style>
    .connectors {
        margin: 10px 0;
        padding: 10px;
        border: 1px solid red;
    }
</style>

{#if item.inquiry.status === 'EXECUTING' 
    || item.inquiry.status === 'GENERATING REPORT' 
    || item.inquiry.status === 'REPORT SUCCESS'
    || item.inquiry.status === 'REPORT AVAILABLE'
    || item.inquiry.status === 'REPORT ERROR'}
    <div class:loading={loading} class="connectors ui segment">
        {#each statuses as status}
            <SourceProgress {item} {status} />
        {/each}                                                            
    </div>
{:else if item.inquiry.status === 'DENIED'}
    <div class="ui icon red message">
        <i class="ban icon"></i>
        <div class="content">
            <div class="header">
                Pedido Negado
            </div>
            <p>
                A execução deste pedido foi negada: { reason(item.inquiry.transitions) }
            </p>
        </div>
    </div>
{:else}
    <div class="ui icon violet message">
        <i class="hourglass outline icon"></i>
        <div class="content">
            <div class="header">
                Aguardando Execução
            </div>
            <p>Este pedido ainda não está em execução</p>
        </div>
    </div>
{/if}
